<template>
  <vue-modal id="digitalReservationStartModal"
             classes="vue-modal-container"
             height="auto"
             name="digital-reservation-start-modal"
             scrollable
             width="80%"
             @closed="modalClosed"
             @opened="modalOpened"
             @before-open="beforeModalOpen">
    <div class="header">
      <h3 v-if="step === 'START'">{{ trans.header }}</h3>
      <h3 v-else-if="step === 'PAYMENT_REQUIRED'">{{ trans.headerStep1 }}</h3>
      <h3 v-else-if="step === 'CONFIRM_ATTEND'">{{ trans.headerStep2 }}</h3>
      <h3 v-else-if="step === 'SUCCESS'">{{ trans.headerStepSuccess }}</h3>
      <div v-else-if="step === 'BUY_OTHER_ITEMS'">
        <h3>Termékek vásárlása</h3>
        <div style="margin-bottom:.4em;">Amennyiben nem tudja a foglalási kódját, kérje el a pultostól!</div>
      </div>
      <button class="close-modal"
              @click="$modal.hide('digital-reservation-start-modal')">
        <i class="close icon"/>
      </button>
      <div v-if="step === 'START'">
        <input id="digitalReservationCodeInput"
               v-model="reservationCode"
               :placeholder="trans.reservationCodePlaceholder"
               class="digital-input"
               maxlength="6"
               oninput="this.value = this.value.toUpperCase()"
               type="text">
      </div>
      <div v-else-if="step === 'PAYMENT_REQUIRED'">
        <div class="">Foglalás kezdete: {{ getFormattedDateTime(reservationData.reservationStart)  }}</div>
        <div class="">Pálya: {{ reservationData.subjectName }}</div>
        <div v-if="negativeBalance"
             class="">Negatív egyenleg: {{ getFormattedCurrency(negativeBalance) }}
        </div>
        <div class="">Foglalás összege: {{ getFormattedCurrency(reservationData.amount) }}</div>
        <div class="">Fizetendő: {{ getFormattedCurrency(needToPayNow) }}</div>
        <div v-if="passes.length > 0"
             class="">
          Felhasználható bérletek:
          <div class="ui form field">
            <select v-model="selectedPass">
              <option v-for="pass in passes"
                      :value="pass.ID">{{ pass.name }} ({{ pass.occasion }}/{{ pass.currentOccasion }})
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-else-if="step === 'CONFIRM_ATTEND'">
        <div class="">Foglalás kezdete: {{ getFormattedDateTime(reservationData.reservationStart) }}</div>
        <div class="">Pálya: {{ reservationData.subjectName }}</div>
      </div>
      <div v-else-if="step === 'POS_LOADING'">
        <h3>Fizetés feldolgozás alatt <br/>
        Kövesse a terminál utasításait</h3>
        <lottie-animation
          :width="300"
          path="static/img/fp-pos-loading.json"
        />
      </div>
      <div v-else-if="step === 'SUCCESS'">
        <div class="">Foglalás kezdete: {{ getFormattedDateTime(reservationData.reservationStart) }}</div>
        <div class="">Pálya: {{ reservationData.subjectName }}</div>
        <img alt="success"
             src="/static/img/rocket.svg"
             width="100px"/>
      </div>
      <div v-else-if="step === 'BUY_OTHER_ITEMS'">
        <div v-if="$store.state.availableItems.length > 0"
             class="">
          <!--          TODO: client filter -->
          <input v-model="reservationCodeForItemBuy"
                 :placeholder="trans.reservationCodePlaceholder"
                 class="digital-input margin-bottom-1"
                 maxlength="6"
                 oninput="this.value = this.value.toUpperCase()"
                 type="text">
          <div v-for="item in $store.state.availableItems.filter(i => i.itemType === 'other')"
               class="col-12">
            <div class="row bordered align-center-middle"
                 style="max-width: 400px;">
              <div class="column col-4">{{ item.name }}</div>
              <div class="column col-4">
                <button :disabled="!purchaseOtherItems[item.id] || purchaseOtherItems[item.id] === 0"
                        class="ui icon button small"
                        @click="decPurchaseOtherItem(item.id)">-
                </button>
                <span class="">{{ purchaseOtherItems[item.id] || 0 }} </span>
                <button :disabled="purchaseOtherItems[item.id] >= maxItemQuantity"
                        class="ui icon button small"
                        @click="incPurchaseOtherItem(item.id)">+
                </button>
              </div>
              <div class="column col-4"> {{ getFormattedCurrency(item.price) }}</div>
            </div>
          </div>
          <div class="margin-top-1">
            Összeg: {{ getFormattedCurrency(getPurchaseTotal()) }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="step === 'START'"
         class="content">
      <button :class="''"
              class="digital-confirm-btn"

              @click="getReservationDetailsByReservationCode(reservationCode)">
        <!--
        TODO: androud problem:
        :disabled="!isCodeValid"
        @click=" isCodeValid ? getReservationDetailsByReservationCode(reservationCode) : () => {}">
        -->
        {{ trans.reservationCodeConfirmBtn }}
      </button>
    </div>
    <div v-else-if="step === 'PAYMENT_REQUIRED'"
         class="content">
      <button class="digital-confirm-btn"
              @click="startPOSPaymentWithReservationCode">
        {{ trans.reservationPaymentStartBtn }}
      </button>
      <button v-if="passes.length > 0"
              class="digital-confirm-btn secondary-type"
              @click="startPaymentWithPass">
        {{ trans.reservationPaymentWithPassStartBtn }}
      </button>
    </div>
    <div v-else-if="step === 'BUY_OTHER_ITEMS'"
         class="content">
      <button :disabled="getPurchaseTotal() <= 0 || !reservationCodeForItemBuy || reservationCodeForItemBuy.length !== 6"
              class="digital-confirm-btn"
              @click="startOtherItemsPOSPayment">
        {{ trans.reservationPaymentStartBtn }}
      </button>
    </div>
    <div v-else-if="step === 'CONFIRM_ATTEND'"
         class="content">
      <button class="digital-confirm-btn"
              @click="attendReservation">
        {{ trans.attendReservationBtn }}
      </button>
      <button class="digital-confirm-btn"
              @click="step = 'START'">
        {{ trans.attendCancelBtn }}
      </button>
    </div>
<!--    <div v-if="step !== 'BUY_OTHER_ITEMS'"-->
<!--         class="content">-->
<!--      <button class="digital-confirm-btn"-->
<!--              @click="step = 'BUY_OTHER_ITEMS'">-->
<!--        {{ trans.buyOtherItemsBtn }}-->
<!--      </button>-->
<!--    </div>-->
  </vue-modal>
</template>

<script>
import {mapState} from 'vuex'
import config from '@/config';
import utils, {getFormattedCurrency} from '@/utils';
import {getFormattedDateTime} from '../../../../foglaljpalyat-client/src/processors/util';
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs

export default {
  components: { LottieAnimation },
  data () {
    return {
      reservationCode: null,
      reservationCodeForItemBuy: null,
      step: 'START', // START, PAYMENT_REQUIRED, CONFIRM_ATTEND, SUCCESS, BUY_OTHER_ITEMS, POS_LOADING
      reservationData: null,
      needPOSPayment: false,
      negativeBalance: false,
      needToPayNow: false,
      passes: [],
      selectedPass: null,
      purchaseOtherItems: {},
      maxItemQuantity: 4,
    }
  },
  methods: {
    getFormattedDateTime,
    beforeModalOpen (event) {
      if (event?.params?.initialState)
        this.step = event.params.initialState
    },
    incPurchaseOtherItem (itemID) {
      if (this.purchaseOtherItems[itemID]) {
        this.purchaseOtherItems[itemID]++
      } else {
        const newItem = {}
        newItem[itemID] = 1
        this.purchaseOtherItems = { ...this.purchaseOtherItems, ...newItem }
      }
    },
    decPurchaseOtherItem (itemID) {
      if (this.purchaseOtherItems[itemID] && this.purchaseOtherItems[itemID] > 0) {
        this.purchaseOtherItems[itemID]--
      } else {
        this.purchaseOtherItems[itemID] = 0
      }
    },
    getPurchaseTotal () {
      let total = 0
      for (const key of Object.keys(this.purchaseOtherItems)) {
        total += this.$store.state.availableItems.find(i => Number(i.id) === Number(key)).price * this.purchaseOtherItems[key]
      }
      return total
    },
    getFormattedCurrency,
    modalOpened () {
      if (this.step === 'START') {
        document.getElementById('digitalReservationCodeInput').focus();
      }
    },
    modalClosed () {
      this.reservationCode = null;
      this.reservationCodeForItemBuy = null;
      this.step = 'START'
      this.reservationData = null
      this.needPOSPayment = false
      this.negativeBalance = false
      this.needToPayNow = false
      this.passes = []
      this.selectedPass = null
      this.purchaseOtherItems = {}
    },
    startPaymentWithPass () {
      this.$http({
        url: config.SERVER_DOMAIN + '/api/global/start-with-reservation-code-pass',
        method: 'POST',
        params: {
          ...this.$store.getters.getAuthParams,
          reservationCode: this.reservationCode,
          passId: this.selectedPass,
        },
      }).then(
        (resp) => {
          if (resp.data) {
            this.step = 'SUCCESS'
            // TODO: timer to close...
          }
        },
        (error) => {
          utils.httpError(error)
        },
      );
    },
    async startPOSPaymentWithReservationCode () {
      await this.$store.dispatch(
        'startPOSPaymentWithReservationCode',
        this.reservationCode,
      )
      this.step = 'POS_LOADING'
    },
    async startOtherItemsPOSPayment () {
      await this.$store.dispatch(
        'startOtherItemsPOSPayment',
        {
          boughtItems: Object.keys(this.purchaseOtherItems).map(key => {
            return { id: key, quantity: this.purchaseOtherItems[key] }
          }),
          reservationCode: this.reservationCodeForItemBuy,
        },
      )
      this.step = 'POS_LOADING'
    },
    attendReservation () {
      this.$http({
        url: config.SERVER_DOMAIN + '/api/global/start-with-reservation-code-play',
        method: 'POST',
        params: {
          ...this.$store.getters.getAuthParams,
          reservationCode: this.reservationCode,
        },
      }).then(
        (resp) => {
          if (resp.data) {
            this.step = 'SUCCESS'
            // TODO: timer to close...
            // this.$modal.hide('digital-reservation-start-modal')
          }
        },
        (error) => {
          utils.httpError(error)
        },
      );
    },
    getReservationDetailsByReservationCode: function (reservationCode) {
      this.$http({
        url: config.SERVER_DOMAIN + '/api/global/get_reservation_details_by_reservation_code',
        method: 'GET',
        params: {
          ...this.$store.getters.getAuthParams,
          reservationCode: reservationCode,
        },
      }).then(
        (resp) => {
          if (resp.data) {
            this.reservationData = resp.data.reservationData
            this.needPOSPayment = resp.data.needPOSPayment
            this.negativeBalance = resp.data.negativeBalance
            this.needToPayNow = resp.data.needToPayNow
            this.passes = resp.data.passes
            if (resp.data.needPOSPayment) {
              this.step = 'PAYMENT_REQUIRED'
              // this.step = 'BUY_OTHER_ITEMS'
              if (this.passes.length > 0) this.selectedPass = this.passes[0].ID
            } else if (resp.data.reservationData) {
              this.step = 'CONFIRM_ATTEND'
            }
          }
          console.log('getReservationDetailsByReservationCode', resp.data)
        },
        (error) => {
          utils.httpError(error)
        },
      );
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.digitalReservationStartModal,
    }),
    isCodeValid: function () {
      return !!this.reservationCode && this.reservationCode.length === 6
    },
  },
}
</script>

<style scoped>
.digital-input {
  width: 50%;
  height: 50px;
  font-size: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.digital-confirm-btn {
  width: 50%;
  height: 50px;
  font-size: 20px;
  padding: 10px;
  //border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  background: #f2711c;
  color: white;
}

.digital-confirm-btn:hover {
  background: #f2711ce0;
}

.digital-confirm-btn.secondary-type {
  background: rgb(28, 89, 242);
}

.digital-confirm-btn.secondary-type:hover {
  background: rgba(28, 89, 242, 0.88);
}

.digital-confirm-btn:disabled {
  opacity: .7;
  background: #f2711c;
  color: white;
  cursor: not-allowed;
}
</style>
